import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'

import {
    selectPaymentOption
} from './paymentMethodActionCreators'

import {
    CheckoutSection,
    hiddenAnchorStyle
} from '../../components'

import {
    OptionListItemRadio
} from '../../../SharedComponents/OptionList'

import { Fade } from '../../componentAnimations'
import analyticsUtility from '../../../util/analyticsUtility'

const getById = (methods, id) => {
    return methods.filter(pm => pm.Id === id)[0];
}

class CheckoutPayment extends React.Component {
    constructor(props) {
        super(props);
        this.onItemSelected = this.onItemSelected.bind(this)
    }

    onItemSelected(id) {
        const paymentOption = getById(this.props.paymentOptions, id);
        if (!paymentOption) {
            console.error(`No payment method with id '${id}'`);
            return;
        }
        analyticsUtility.addPaymentInfo(this.props.coupon.Code, paymentOption.Name, this.props.checkoutItems);
        this.props.onSelected(id, paymentOption.Name);
    }

    render() {
        const items = this.props.paymentOptions.map(pm => {
            let selected = pm.Id === this.props.selectedPaymentOptionId;
            const visible = !this.props.selectedPaymentOptionId || selected;
            if (pm.paymentOptionComponent) {
                const PaymentOptionComponent = pm.paymentOptionComponent;

                return (
                    <OptionListItemRadio
                        key={pm.Id}
                        id={pm.Id}
                        isSelected={selected}
                        onClick={this.onItemSelected}
                        label={pm.Name}
                        hidden={!visible}>
                        <div>
                            <PaymentOptionComponent
                                isSelected={selected}
                                onPaymentCancel={this.props.onCancel}
                            />
                        </div>
                    </OptionListItemRadio>
                )
            } else {
                return (<OptionListItemRadio
                    key={pm.Id}
                    id={pm.Id}
                    isSelected={selected}
                    onClick={this.onItemSelected}
                    label={pm.Name}
                    hidden={!visible} />)
            }
        });
        return (
            <CheckoutSection label={"Payment Information"} hidden={false}>
                <div style={{ display: 'inherit' }}>
                    {items}
                </div>
            </CheckoutSection>
        );
    }
}

const formatPayment = ({ constants, entities }) => {

    const formatPaypalPayloadDetailsForSummary = (det) => {
        if (det) {
            if (typeof (det.firstName) !== 'undefined' && typeof (det.lastName) !== 'undefined' && typeof (det.email) !== 'undefined') {
                return `${det.firstName.length > 0 ? det.firstName + " " : ""}${det.lastName.length > 0 ? det.lastName + " " : ""} (${det.email})`;
            } else if (typeof (det.email) !== 'undefined' && det.email.length > 0) {
                return det.email;
            }
        }
        return "unspecified";
    }

    let formatters = [
        {
            Id: constants.purchaseOrderPaymentId,
            format: ({ POValue }) =>
                (`Purchase Order ${((POValue && POValue.length > 0) ? " #: " : "")}${POValue || ""}`)
        },
        {
            Id: constants.braintreeSettings.braintreePaymentId,
            format: ({ BraintreePaymentPayload }) => {
                if (!BraintreePaymentPayload) {
                    return "Pending";
                } else {
                    if (BraintreePaymentPayload.type === "PayPalAccount") {
                        return `Paypal: ${formatPaypalPayloadDetailsForSummary(BraintreePaymentPayload.details)}`;
                    } else if (BraintreePaymentPayload.type === "CreditCard") {
                        return `Card: ${BraintreePaymentPayload.description}`
                    } else {
                        return "Unknown payment method";
                    }

                }
            }
        }
    ];
    const formatter = find(formatters, x => x.Id === entities.SelectedPaymentOptionId);
    if (formatter) {
        return formatter.format(entities.PaymentRecord);
    }
}

const mapCheckoutPaymentStateToProps = (state) => {
    return {
        paymentOptions: state.entities.PaymentOptions,
        selectedPaymentOptionId: state.entities.SelectedPaymentOptionId,
        selectedDisplay: formatPayment(state),
        checkoutItems: state.entities.GA4CheckoutItems,
        coupon: state.entities.Coupons && state.entities.Coupons.length > 0 ? state.entities.Coupons[0] : null
    }
}

const mapCheckoutPaymentDispatchToProps = (dispatch) => {
    return {
        onSelected: (id, displayName) => dispatch(selectPaymentOption(id, displayName)),
        onCancel: () => dispatch(selectPaymentOption(''))
    }
}

const CheckoutPaymentContainer = connect(
    mapCheckoutPaymentStateToProps,
    mapCheckoutPaymentDispatchToProps
)(CheckoutPayment);


export default CheckoutPaymentContainer